import { formatPercent } from '../lib/sentiment';

interface Probabilities {
  positive: number;
  neutral: number;
  negative: number;
}

/**
 * The three class probabilities as one proportional bar. Decorative: every
 * place that renders it also states the result in text.
 */
export function SentimentStrip({
  positive,
  neutral,
  negative,
  large = false,
}: Probabilities & { large?: boolean }) {
  return (
    <div className={large ? 'strip strip-lg' : 'strip'} aria-hidden="true">
      <span className="strip-positive" style={{ flexGrow: positive }} />
      <span className="strip-neutral" style={{ flexGrow: neutral }} />
      <span className="strip-negative" style={{ flexGrow: negative }} />
    </div>
  );
}

export function StripLegend({ positive, neutral, negative }: Probabilities) {
  return (
    <p className="strip-legend">
      <span className="key-positive">
        <strong>{formatPercent(positive)}</strong> positive
      </span>
      <span className="key-neutral">
        <strong>{formatPercent(neutral)}</strong> neutral
      </span>
      <span className="key-negative">
        <strong>{formatPercent(negative)}</strong> negative
      </span>
    </p>
  );
}
